__turbopack_context__.v({
  "appPlatformLogos": "download-module-scss-module__yswffW__appPlatformLogos",
  "download": "download-module-scss-module__yswffW__download",
  "downloadTheHera": "download-module-scss-module__yswffW__downloadTheHera",
  "groupIcon": "download-module-scss-module__yswffW__groupIcon",
  "groupIcon1": "download-module-scss-module__yswffW__groupIcon1",
  "storeLink": "download-module-scss-module__yswffW__storeLink",
});
